"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BugTooltipSk", {
    enumerable: true,
    get: function() {
        return BugTooltipSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let BugTooltipSk = class BugTooltipSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        return (0, _lit.html)`
      <div class="bug-count-container" ?hidden=${this.bugs.length === 0}>
        <span>with ${this.bugs.length} ${this.totalLabel}</span>
        <div class="bug-tooltip">
          ${(0, _lit.html)`
            <ul>
              ${this.bugs.map((bug)=>(0, _lit.html)`<li>
                    <a href="http://b/${bug.bug_id}" target="_blank">${bug.bug_id}</a
                    ><span> from ${bug.bug_type}</span>
                  </li>`)}
            </ul>
          `}
        </div>
      </div>
    `;
    }
    constructor(...args){
        super(...args);
        this.bugs = [];
        this.totalLabel = 'total';
    }
};
_ts_decorate([
    (0, _decorators.property)({
        type: Array
    }),
    _ts_metadata("design:type", Array)
], BugTooltipSk.prototype, "bugs", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    }),
    _ts_metadata("design:type", String)
], BugTooltipSk.prototype, "totalLabel", void 0);
BugTooltipSk = _ts_decorate([
    (0, _decorators.customElement)('bug-tooltip-sk')
], BugTooltipSk);
